// extracted by mini-css-extract-plugin
export default {"MNPSection":"MNPSection_MNPSection__kHhQQ"};